import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { visuallyHiddenSx } from '../../../core-components/theme/components/Fields/fieldStyles';
import { COUNTRY_PREFIX } from '../../../utilities/formatPhone';

export const joinIds = (...ids: ReadonlyArray<string | undefined>): string | undefined => {
  const present = ids.filter((id): id is string => id !== undefined && id !== '');
  return present.length === 0 ? undefined : present.join(' ');
};

export const CountryPrefix: React.FC<{ readonly id: string }> = ({ id }) => {
  const { t } = useTranslation();
  return (
    <Box component="span" id={id}>
      <Box component="span" sx={visuallyHiddenSx}>
        {t('passcodeAuth.phone.countryCode', 'Country code')}{' '}
      </Box>
      {COUNTRY_PREFIX}
    </Box>
  );
};
